var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("TitleWithRow", { attrs: { title: "Anexos de imagens" } }),
      _vm._v(" "),
      _c("p", { staticClass: "mb-2 font-size-1" }, [
        _vm._v("Selecione as fotos que você deseja utilizar")
      ]),
      _vm._v(" "),
      _c("app-documentos", {
        attrs: {
          maxSize: 25000,
          "valid-extensions": ["jpg", "jpeg", "png", "heic", "heif"],
          documentos: _vm.fotos,
          tiposDocumentos: _vm.tiposDocumentos,
          tiposDocumentosObrigatorios: _vm.tiposDocumentosObrigatorios,
          aba: "Galeria",
          visualizarlabelTitulo: false,
          pathDocumentosRemover: _vm.pathDocumentosRemover
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2275b124", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2275b124","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App/(authenticated)/modulos/cadastro/formulario-cadastro/anexos/anexos.vue
// module id = null
// module chunks = 